import { render, staticRenderFns } from "./BuildingIndex.vue?vue&type=template&id=03db9926&scoped=true&"
import script from "./BuildingIndex.vue?vue&type=script&lang=ts&"
export * from "./BuildingIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03db9926",
  null
  
)

export default component.exports